import { useEffect } from "react";
import { RTL_LANGS } from "@/lib/i18n";

export default function useDocumentLocale(lang, title) {
  useEffect(() => {
    const root = document.documentElement;
    const previous = { lang: root.lang, dir: root.dir, title: document.title };
    root.lang = lang;
    root.dir = RTL_LANGS.has(lang) ? "rtl" : "ltr";
    if (title) document.title = title;
    return () => {
      root.lang = previous.lang;
      root.dir = previous.dir;
      document.title = previous.title;
    };
  }, [lang, title]);
}
